import type { RootStateOrAny } from 'react-redux'
import { useSelector } from 'react-redux'

import { getUserOrdersWithRecipes } from 'selectors/user'

import {
  type RecommendationsCollectionForTutorial,
  useShowJFYTutorial,
} from '../JustForYouTutorial/useShowJFYTutorial'

export const MENU_PREFERENCES_TUTORIAL_NAME = 'customised_recipe_tiles_menu_preferences'

export const useShouldShowMenuPreferencesTutorial = (
  recommendationsCollection?: RecommendationsCollectionForTutorial | null,
) => {
  const ordersWithRecipes = useSelector(getUserOrdersWithRecipes)
  const showJFYTutorial = useShowJFYTutorial(recommendationsCollection)
  const hasViewedTutorial = useSelector(({ tutorial }: RootStateOrAny) =>
    Boolean(tutorial && tutorial.getIn(['viewed', MENU_PREFERENCES_TUTORIAL_NAME])),
  )

  return Boolean(ordersWithRecipes?.size > 1 && !hasViewedTutorial && !showJFYTutorial)
}
